import React from 'react';
import { DOCUMENT_SELECTION_MODES } from '@constants';
import { DocumentSelectionModalControlled } from '@features/document/DocumentSelectionModal/DocumentSelectionModalControlled';
import { logger } from '@utils/usefulFuncs';

const docSelectModes = [DOCUMENT_SELECTION_MODES.allCompany, DOCUMENT_SELECTION_MODES.myDocs];

export const DocSelectionModalController = ({ onInit }) => {
  const [activeNodeId, setActiveNodeId] = React.useState(null);
  const [value, setValue] = React.useState([]);
  const onChangeRef = React.useRef(() => {
    logger('onChangeRef is still not set');
  });

  const showModal = (nodeId, value, onChange) => {
    setActiveNodeId(nodeId);
    setValue(value || []);
    onChangeRef.current = onChange;
  };

  const hideModal = () => {
    setActiveNodeId(null);
  };

  React.useEffect(() => {
    onInit({ showModal, hideModal });
  }, []);

  if (!activeNodeId) {
    return null;
  }

  const handleSelectedDocsChange = (nextValue) => {
    onChangeRef.current(nextValue);
    setValue(nextValue);
  };
  return (
    <DocumentSelectionModalControlled
      docMode={docSelectModes[0]}
      defaultActiveMode={docSelectModes[0]}
      documentSelectionModes={docSelectModes}
      selectedDocs={value}
      onSelectedDocsChange={handleSelectedDocsChange}
      onDismiss={hideModal}
    />
  );
};
